/**
 * Tiered free gifts — 16 Oct 2026 rewrite: FIXED GIFT PER TIER.
 *
 *   Tier 1  every order        -> settings.fg_t1_product auto-added (qty 1)
 *   Tier 2  >= fg_t2_threshold -> gift A (the "duffle" slot) auto-added
 *   Tier 3  >= fg_t3_threshold -> gift B (the "set" slot) auto-added, ON TOP
 *
 * The tiers are cumulative: a cart over tier 3 carries BOTH gifts.
 *
 * 18 Oct 2026: gift SKUs added to the cart by hand (they are £0.00 and
 * publicly purchasable) are now removed. Before this, only lines carrying
 * our _free_gift property were reconciled, so a shopper could search up the
 * gift products and add as many free ones as they liked.
 *
 * Gift lines carry line item properties:
 *   _free_gift: 'tier1' | 'premium'
 *   _fg_pick:   'duffle' | 'set'      (premium gifts only)
 *   _fg_slot:   '1' | '2'             (premium gifts only)
 */
(function () {
  if (window.freeGiftLoaded) return;
  window.freeGiftLoaded = true;

  var busy = false;
  var lastT1Present = null;
  var T1_OPTOUT_KEY = 'fg_t1_optout';

  function cfg() {
    var el = document.querySelector('[data-free-gift]');
    if (!el) return null;
    return {
      el: el,
      t2: parseInt(el.getAttribute('data-gift-t2'), 10) || 0,
      t3: parseInt(el.getAttribute('data-gift-t3'), 10) || 0,
      fx: el.getAttribute('data-gift-fx'),
      t2Base: parseFloat(el.getAttribute('data-gift-t2-base')) || 0,
      t3Base: parseFloat(el.getAttribute('data-gift-t3-base')) || 0,
      shopCurrency: el.getAttribute('data-shop-currency'),
      t1Variant: parseInt(el.getAttribute('data-t1-variant'), 10) || 0,
      variants: {
        duffle:
          parseInt(el.getAttribute('data-duffle-t2-variant'), 10) ||
          parseInt(el.getAttribute('data-duffle-t3-variant'), 10) ||
          0,
        set:
          parseInt(el.getAttribute('data-set-t3-variant'), 10) ||
          parseInt(el.getAttribute('data-set-t2-variant'), 10) ||
          0,
      },
      giftHandles: (el.getAttribute('data-gift-handles') || '').split(',').filter(Boolean),
    };
  }

  function t1OptedOut() {
    try { return sessionStorage.getItem(T1_OPTOUT_KEY) === '1'; } catch (e) { return false; }
  }
  function setT1OptOut() {
    try { sessionStorage.setItem(T1_OPTOUT_KEY, '1'); } catch (e) { /* noop */ }
  }
  function clearT1OptOut() {
    try { sessionStorage.removeItem(T1_OPTOUT_KEY); } catch (e) { /* noop */ }
  }

  /* ---- cart state ---- */
  function readState(cart, c) {
    var gifts = [];
    var strays = [];
    var countableTotal = cart.total_price;
    var nonGiftCount = 0;
    var countableCount = 0;
    cart.items.forEach(function (item) {
      var isTagged = item.properties && item.properties._free_gift;
      var isGiftProduct = c.giftHandles.indexOf(item.handle) !== -1;
      if (isTagged) {
        gifts.push(item);
      } else if (isGiftProduct) {
        // A gift SKU in the cart WITHOUT our property was not put there by
        // this script — the customer added it straight from the product
        // page. It is not a gift we owe them, so it gets removed, not kept.
        strays.push(item);
      } else {
        nonGiftCount += 1;
      }
      if (isTagged || isGiftProduct) {
        countableTotal -= item.final_line_price;
      } else {
        countableCount += 1;
      }
    });
    var t1Line = gifts.find(function (g) { return g.properties._free_gift === 'tier1'; });
    var picks = gifts.filter(function (g) { return g.properties._fg_pick; });
    var allowance = 0;
    if (countableCount > 0) {
      if (c.t3 > 0 && countableTotal >= c.t3) allowance = 2;
      else if (c.t2 > 0 && countableTotal >= c.t2) allowance = 1;
    }
    return {
      gifts: gifts,
      strays: strays,
      nonGiftCount: nonGiftCount,
      countableCount: countableCount,
      t1Line: t1Line,
      picks: picks,
      allowance: allowance,
    };
  }

  function picksOf(state, option) {
    return state.picks.filter(function (p) { return p.properties._fg_pick === option; });
  }

  /* ---- cart plumbing ---- */
  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    });
  }

  function giftItem(c, option, slot) {
    return {
      id: c.variants[option],
      quantity: 1,
      properties: { _free_gift: 'premium', _fg_pick: option, _fg_slot: slot },
    };
  }

  function refreshCartDrawer() {
    return fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newDrawer = doc.querySelector('cart-drawer');
        var oldDrawer = document.querySelector('cart-drawer');
        if (newDrawer && oldDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;
      });
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
      el.textContent = count;
    });
  }

  function afterMutation() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshCartDrawer();
      });
  }

  function chain(ops) {
    return ops.reduce(function (p, op) { return p.then(op); }, Promise.resolve());
  }

  /**
   * One gift slot, reconciled against what the cart should hold.
   * want=true  -> exactly one line of the right variant, quantity 1
   * want=false -> no lines at all
   */
  function reconcileSlot(c, state, option, slot, want, ops) {
    var mine = picksOf(state, option);
    var wanted = c.variants[option];
    if (!wanted) return;

    if (!want) {
      mine.forEach(function (p) {
        ops.push(function () { return changeLine(p.key, 0); });
      });
      return;
    }

    var keeper = null;
    mine.forEach(function (p) {
      if (!keeper && p.variant_id === wanted) keeper = p;
      else ops.push(function () { return changeLine(p.key, 0); });
    });

    if (keeper) {
      if (keeper.quantity !== 1) {
        ops.push(function () { return changeLine(keeper.key, 1); });
      }
    } else {
      ops.push(function () { return addItems([giftItem(c, option, slot)]); });
    }
  }

  /* ---- cleanup: keep the cart state legal ---- */
  function checkGift() {
    var c = cfg();
    if (!c || busy) return;
    busy = true;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var state = readState(cart, c);
        var ops = [];

        // Cart holds only gifts -> everything goes.
        if (state.nonGiftCount === 0) {
          var all = state.gifts.concat(state.strays);
          if (!all.length) { lastT1Present = false; return null; }
          lastT1Present = false;
          clearT1OptOut();
          return chain(all.map(function (g) {
            return function () { return changeLine(g.key, 0); };
          })).then(afterMutation);
        }

        // Gift SKUs the customer added by hand: always removed, whatever the
        // cart total. The script owns every gift line; nothing else may be one.
        state.strays.forEach(function (s) {
          ops.push(function () { return changeLine(s.key, 0); });
        });

        // Tier 1 — detect a customer removing it, otherwise auto-add.
        if (state.t1Line) {
          lastT1Present = true;
          if (state.countableCount === 0) {
            ops.push(function () { return changeLine(state.t1Line.key, 0); });
            lastT1Present = false;
          } else if (c.t1Variant && state.t1Line.variant_id !== c.t1Variant) {
            ops.push(function () { return changeLine(state.t1Line.key, 0); });
            ops.push(function () {
              return addItems([{ id: c.t1Variant, quantity: 1, properties: { _free_gift: 'tier1' } }]);
            });
          } else if (state.t1Line.quantity !== 1) {
            ops.push(function () { return changeLine(state.t1Line.key, 1); });
          }
        } else {
          if (lastT1Present === true) setT1OptOut();
          lastT1Present = false;
          if (c.t1Variant && !t1OptedOut() && state.countableCount > 0) {
            ops.push(function () {
              return addItems([{ id: c.t1Variant, quantity: 1, properties: { _free_gift: 'tier1' } }]);
            });
          }
        }

        // Tier 2 and tier 3 gifts — fixed, cumulative, no choosing.
        reconcileSlot(c, state, 'duffle', '1', state.allowance >= 1, ops);
        reconcileSlot(c, state, 'set', '2', state.allowance >= 2, ops);

        if (!ops.length) return null;
        return chain(ops).then(afterMutation);
      })
      .catch(function (e) { console.error('[free-gift]', e); })
      .finally(function () { busy = false; });
  }

  function addTier1Back() {
    var c = cfg();
    if (!c || busy || !c.t1Variant) return;
    busy = true;
    clearT1OptOut();
    addItems([{ id: c.t1Variant, quantity: 1, properties: { _free_gift: 'tier1' } }])
      .then(afterMutation)
      .catch(function (e) { console.error('[free-gift]', e); })
      .finally(function () { busy = false; lastT1Present = true; });
  }

  /* ---- currency conversion ---- */
  var fxAttempts = 0;
  function syncFx() {
    var c = cfg();
    if (!c || c.fx !== 'auto' || busy || fxAttempts > 4) return;
    if (!(window.Shopify && Shopify.currency && Shopify.currency.rate && Shopify.currency.active)) return;

    var active = Shopify.currency.active;
    if (!c.shopCurrency || active === c.shopCurrency) return;

    var rate = parseFloat(Shopify.currency.rate);
    if (!rate || !c.t2Base || !c.t3Base) return;

    var want2 = Math.round(c.t2Base * rate) * 100;
    var want3 = Math.round(c.t3Base * rate) * 100;
    if (c.t2 === want2 && c.t3 === want3) return;

    fxAttempts += 1;
    busy = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: { _fg_thr2: String(want2), _fg_thr3: String(want3), _fg_thr_ccy: active },
      }),
    })
      .then(afterMutation)
      .catch(function (e) { console.error('[free-gift fx]', e); })
      .finally(function () { busy = false; });
  }

  /* ---- announcement bar amounts ---- */
  function updateAnnouncementAmounts() {
    var els = document.querySelectorAll('[data-gift-amt]');
    if (!els.length) return;
    if (!(window.Shopify && Shopify.currency && Shopify.currency.active)) return;
    var active = Shopify.currency.active;
    var shopCurrency = els[0].getAttribute('data-gift-amt-shop') || '';
    if (active === shopCurrency) return;
    var rate = parseFloat(Shopify.currency.rate);
    if (!rate) return;
    els.forEach(function (el) {
      var base = parseFloat(el.getAttribute('data-gift-amt-base'));
      if (!base) return;
      var amount = Math.round(base * rate);
      try {
        el.textContent = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: active,
          maximumFractionDigits: 0,
        }).format(amount);
      } catch (e) {
        el.textContent = amount + ' ' + active;
      }
    });
  }

  /* ---- events ---- */
  document.addEventListener('click', function (e) {
    var t1 = e.target.closest('[data-gift-t1-add]');
    if (t1) {
      e.preventDefault();
      addTier1Back();
    }
  });

  // Re-check after any cart mutation made anywhere in the theme.
  var CART_MUTATION_RE = new RegExp('/cart/(add|change|update|clear)');
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var result = origFetch.apply(this, arguments);
    if (CART_MUTATION_RE.test(url)) {
      result.then(function () { setTimeout(checkGift, 150); }).catch(function () {});
    }
    return result;
  };

  document.addEventListener('cart:updated', function () {
    setTimeout(checkGift, 150);
    setTimeout(syncFx, 400);
  });

  function init() {
    setTimeout(syncFx, 200);
    setTimeout(checkGift, 400);
    setTimeout(updateAnnouncementAmounts, 250);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
